import 'libraries/angular.min.js';
import 'node_modules/air-datepicker/dist/js/datepicker.min.js';
import 'node_modules/air-datepicker/dist/js/i18n/datepicker.en.js';

var angularApp = angular.module('myApp', []);

angularApp.controller('PredictionCtrl', function ($scope, $http) {

    $scope.date = "today";
    $scope.type = "1x2";
    $scope.items = [];
    $scope.limit = apLimit;
    $scope.hide = ApHideBad;
    $scope.auth_user = auth;

    $scope.getPredictions = function () {
        $http.get("/predictions/?type=" + $scope.type + "&date=" + $scope.date + "&limit=" + $scope.limit + "&hide=" + $scope.hide)
            .then(function (response) {
                $scope.items = response.data;
                $(".lb-navbar-upcoming").removeClass('progress-lb');
                setTimeout(function () {
                    $scope.showOddsPanel();
                }, 300);

            });
    }

    $scope.isEmpty = function (obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    };

    $scope.hidePanel = function () {
        $("[data-dock]").append($("[data-bet-panel]"));
    }

    $scope.setType = function (type, $event) {
        $scope.hidePanel();
        $scope.type = type;

        if ('currentTarget' in $event)
            $($event.currentTarget).addClass('progress-lb');

        $scope.getPredictions();
    }

    $scope.setDate = function (date) {
        $('.rightside a').removeClass('active');
        $('.rightside span label').removeClass('active');
        $scope.hidePanel();
        $scope.date = date;
        $('.rightside a.' + date).addClass('active');
        $scope.getPredictions();
    }

    $scope.getPredictions();

    $(document).ready(function () {
        var start = new Date(),
            Day;
        $('#example-show-hide-callbacks').datepicker({
            startDate: start,
            autoClose: true,
            position: "bottom right",
            language: "en",
            onSelect: function (fd, d, picker) {
                if (!d) return;
                var DateSelect = formatDate(d)
                $scope.setDate(DateSelect);
                $('.rightside span label').addClass('active');
                $scope.$apply();
                if (Day != undefined && Day == day) return;

            }
        })
    });

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    $scope.showOddsPanelFirst = function (event) {}

    $scope.showOddsPanel = function toggleSelection($event) {
        var element;
        if (typeof $event == "undefined") {
            element = $(".prediction").eq(0).find(".more-odds").eq(0).get();
        } else {
            element = $event.currentTarget;
        }

        var obBox = $(element).parents(".event-box");
        $(".more-odds").removeClass('activebutton');
        $(element).addClass('activebutton');
        obBox.after($("[data-bet-panel]"));
    };

});